import React from 'react';
import { useParams } from 'react-router-dom';
import EnhancedTreatmentPlan from '../../components/TreatmentPlan/EnhancedTreatmentPlan';

const TreatmentPlan = ({ patientId: propPatientId, role = 'doctor' }) => {
  const { id: paramPatientId } = useParams();
  const finalPatientId = propPatientId || paramPatientId;

  return (
    <EnhancedTreatmentPlan patientId={finalPatientId} role={role} />
  );
};

export default TreatmentPlan; 